import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { COMPOSER_BREAKPOINTS } from '../../content-composer/constants';

type Props = PropsWithChildren<{
  label: string;
}>;

// TODO: Investigate making the label activate the child input when clicked
export const SettingItem = ({ children, label }: Props) => {
  return (
    <div
      css={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',

        [`@media (min-width: ${COMPOSER_BREAKPOINTS.MOBILE + 1}px) and (max-width: ${COMPOSER_BREAKPOINTS.TABLET}px)`]:
          {
            flexDirection: 'column',
            alignItems: 'flex-start',
          },

        '&:last-of-type': {
          marginBottom: 0,
        },
      }}
    >
      <Text
        css={{
          [`@media (max-width: ${COMPOSER_BREAKPOINTS.TABLET}px)`]: {
            marginBottom: theme.spacing(0.5),
          },
        }}
      >
        {label}
      </Text>
      {children}
    </div>
  );
};
